import React, { useState, useEffect, ChangeEvent } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  SelectChangeEvent
} from "@mui/material";

type ModalProps = {
  open: boolean;
  onClose: () => void;
  onSave: (item: any) => void;
  onCancel: () => void;
  title: string;
  fields: {
    label: string;
    key: keyof any;
    type?: any;
    options?: any[];
    defaultValue?: any;
    required?: boolean;
  }[];
  initialData?: any | null;
};

export const ModalComponent: React.FC<ModalProps> = ({
  open,
  onClose,
  onSave,
  onCancel,
  title,
  fields,
  initialData,
}) => {
  const [formData, setFormData] = useState<any>({});

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({});
    }
  }, [initialData]);

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | { name: string; value: unknown }> | SelectChangeEvent<any>,
  ) => {
    const { name, value } = event.target as HTMLInputElement;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = () => {    
    onSave(formData);
    setFormData({});
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {fields.map((field, index) =>
          field.type === "select" ? (
            <React.Fragment key={field.key as string + index.toString()}>
              <InputLabel id={`${field.key.toString()}-label`} sx={{ mt: 1 }}>
                {field.label}
              </InputLabel>
              <Select
                labelId={`${field.key.toString()}-label`}
                id={field.key as string}
                name={field.key as string}
                value={formData[field.key] || ""}
                onChange={handleChange}
                fullWidth
              >
                {field.options?.map((option: any) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
              {formData[field.key] === "U$D" && (
                <TextField
                  sx={{mt: 2.5}}
                  key={"valorDeCambio"}
                  label="Valor de Cambio"
                  name={"valorDeCambio"}
                  value={formData[`valorDeCambio`] || ""}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
                />
              )}
            </React.Fragment>
          ) : (
            <TextField
              key={field.key as string + index.toString()}
              label={field.label}
              name={field.key as string}
              value={formData[field.key] || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
          )
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} style={{backgroundColor:"#ed3c3cde", color:"#000000"}}>Cancelar</Button>
        <Button onClick={handleSave} style={{backgroundColor:"#6da34cde", color:"#000000"}}>Guardar</Button>
      </DialogActions>
    </Dialog>
  );
};
